class Filters {

    static currency(amount) {

        let decimalCount = 2;
    	let decimal = ",";
    	let thousands = ".";

    	decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return "€" + negativeSign + (j ? i.substring(0, j) + thousands : '') + i.substring(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    }

    static datestring(value) {
        let date = value;

        if ( date !== undefined ) {
            if ( typeof value == 'string' && value.trim() != '' ) {
                date = new Date(value);
            }

            if ( isNaN(date.getTime()) === false ) {

                let day = String(date.getDate()).padStart(2, '0');
                let month = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                let year = date.getFullYear();

                return year + '-' + month + '-' + day;
            }
        }

        return null;
    }

    static prettydate(value) {

        if ( typeof value == 'string' && value.trim() != '' ) {
            let date = new Date(value);

            if ( isNaN(date.getTime()) === false ) {
                return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'long', year: 'numeric'});
            }
        }

        return '-';
    }

    static prettytime(value) {
        if (typeof value=='string' && value.trim() != '') {
            let date = new Date(value);

            if ( isNaN(date.getTime()) === false ) {
                return date.toLocaleTimeString('nl-NL', {hour: 'numeric', minute:'numeric'});
            }
        }
    }

    static addressFirstLine(address) {
        return `${address.name ?? ''} ${address.street ?? ''} ${address.number ?? ''}${/^\d/.test(address.addition) ? '': ''}${address.addition ?? ''}`;
    }

    static addressSecondLine(address) {
        return `${address.zipcode ?? ''} ${address.city ?? ''}`;
    }

    static address = address => this.addressFirstLine(address) + '\n' + this.addressSecondLine(address);

}

export default {
    install: app => {
        app.config.globalProperties.$filter = Filters;
    }
}
